const defaultNotifications = [
    {
        id: 1,
        title: "Bem-vindo à plataforma!",
        description: "Explore os conteúdos e conecte-se com a comunidade.",
        icon: "campaign",
        date: "2022-01-01",
        avatar: 'platform',
        category: 'updates',
        handler: {
            type: 'link',
            value: 'https://help.ginastee.com',
        }
    },
    {
        id: 2,
        title: "Crie sua comunidade com a I.A. Ginastee!",
        description: "Publique seus conteúdos privados, e venda acesso para o público",
        icon: "campaign",
        date: "2022-01-01",
        avatar: 'ai',
        category: 'updates',
        handler: {
            type: 'link',
            value: 'https://builder.ginastee.com',
        }
    },
];

export default defaultNotifications;